module.exports = __webpack_public_path__ + "img/BG1.9056b354.jpg";